import { render, staticRenderFns } from "./MasterProposal.vue?vue&type=template&id=75755588&"
import script from "./MasterProposal.vue?vue&type=script&lang=js&"
export * from "./MasterProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports